const Web3 = require("web3");

if (window.ethereum) {
  window.web3 = new Web3(window.ethereum);
} else if (window.web3) {
  window.web3 = new Web3(window.web3.currentProvider);
}

module.exports = window.web3;
